// Share-link helpers.  Keep in sync with functions/_shared/slug.js (the server
// uses it to build link-preview tags for /viewer/<slug>).

export function slugify(title) {
  const s = String(title || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")      // drop accents
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/['’`]/g, "")                // "Fitzgerald's" -> "fitzgeralds"
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60)
    .replace(/-+$/g, "");
  return s || "ship";
}

// Map of ship id -> slug. If two ships share a name, both get "-<id>" so links stay unique.
export function buildSlugs(ships) {
  const counts = {};
  ships.forEach((s) => { const b = slugify(s.title); counts[b] = (counts[b] || 0) + 1; });
  const map = new Map();
  ships.forEach((s) => {
    const b = slugify(s.title);
    map.set(Number(s.id), counts[b] > 1 ? `${b}-${s.id}` : b);
  });
  return map;
}

// "/viewer/titan-sub" | "/viewer/12" | "/12"  ->  ship | null
export function shipRefFromPath(pathname) {
  const m = pathname.match(/^\/viewer\/([^/]+)\/?$/i) || pathname.match(/^\/(\d+)\/?$/);
  if (!m) return null;
  try { return decodeURIComponent(m[1]).toLowerCase(); } catch { return m[1].toLowerCase(); }
}

export function findShipByRef(ships, slugs, ref) {
  if (!ref) return null;
  ref = slugify(ref); // tolerate spaces / odd casing typed by hand
  const bySlug = ships.find((s) => slugs.get(Number(s.id)) === ref);
  if (bySlug) return bySlug;
  // old/renamed links: a bare id, or "<anything>-<id>"
  const id = /^\d+$/.test(ref) ? ref : (ref.match(/-(\d+)$/) || [])[1];
  return id ? ships.find((s) => String(s.id) === id) || null : null;
}

export const shareUrl = (slugs, ship) => `${window.location.origin}/viewer/${slugs.get(Number(ship.id))}`;

// Contributor profile links: "/user/alfredredbird"  ->  "alfredredbird" | null
export function userFromPath(pathname) {
  const m = String(pathname || "").match(/^\/user\/([^/]+)\/?$/i);
  if (!m) return null;
  try { return decodeURIComponent(m[1]); } catch { return m[1]; }
}
export const userPath = (username) => `/user/${encodeURIComponent(username)}`;
export const userShareUrl = (username) => `${window.location.origin}${userPath(username)}`;

// Public change feed: "/changes" (everything) or "/changes?ship=12" (one ship's history)  ->  { shipId } | null
export function changesFromPath(pathname, search = "") {
  if (!/^\/changes\/?$/i.test(String(pathname || ""))) return null;
  const ship = parseInt(new URLSearchParams(search).get("ship"), 10);
  return { shipId: ship > 0 ? ship : null };
}
export const changesPath = (shipId) => (shipId ? `/changes?ship=${shipId}` : "/changes");
export const changesShareUrl = (shipId) => `${window.location.origin}${changesPath(shipId)}`;
